import { Library } from './Library';

/**
 * Courses — GEN-58, and the first of the four library screens.
 *
 * A thin binding rather than a screen of its own: what differs between courses, paths and
 * modules is the kind, the heading and where a row goes, and everything else is the
 * pattern in `Library`.
 */
export function Courses() {
  return (
    <Library
      kind="COURSE"
      title="Courses"
      detailPath={(id) => `/library/courses/${id}`}
      newPath="new"
      publishes
    />
  );
}
